import React, { Component } from 'react'
import Detail from '../components/Reisadviezen/Detail'
import dynamicPortal from '../utils/dynamicPortal';

export class ReisadviesPortal extends Component {
  render() {
    return dynamicPortal.load('.js-react-reisadvies', (config) => (
      <Detail config={config} />
    ))
  }
}

export default ReisadviesPortal



// WEBPACK FOOTER //
// ./src/portals/ReisadviesPortal.js